import { n as cx } from "./primitives-DLlUP8hy.js";
import { a as DialogDescription, c as DialogTitle, i as DialogCloseIcon, l as DialogTrigger$1, n as DialogBody, o as DialogFooter, r as DialogClose, s as DialogHeader, t as Dialog$1 } from "./dialog-DPHm1qux.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { twJoin } from "tailwind-merge";
import { DialogTrigger, Modal, ModalOverlay } from "react-aria-components";
var Modal$1 = (n) => /* @__PURE__ */ jsx(DialogTrigger, { ...n }), sizes = {
	"2xs": "sm:max-w-2xs",
	xs: "sm:max-w-xs",
	sm: "sm:max-w-sm",
	md: "sm:max-w-md",
	lg: "sm:max-w-lg",
	xl: "sm:max-w-xl",
	"2xl": "sm:max-w-2xl",
	"3xl": "sm:max-w-3xl",
	"4xl": "sm:max-w-4xl",
	"5xl": "sm:max-w-5xl",
	fullscreen: ""
}, ModalContent = ({ className: _, isDismissable: v, isBlurred: y = !1, children: b, overlay: x, size: S = "lg", role: C = "dialog", closeButton: w = !0,...T }) => {
	let E = v ?? C !== "alertdialog";
	return /* @__PURE__ */ jsx(ModalOverlay, {
		"data-slot": "modal-overlay",
		isDismissable: E,
		className: twJoin("fixed inset-0 z-50 h-(--visual-viewport-height,100vh) bg-black/15", "grid grid-rows-[1fr_auto] justify-items-center sm:grid-rows-[1fr_auto_3fr]", S === "fullscreen" ? "md:p-3" : "md:p-4", "entering:fade-in entering:animate-in entering:duration-300 entering:ease-out", "exiting:fade-out exiting:animate-out exiting:ease-in", y && "backdrop-blur-[1px] backdrop-filter"),
		...T,
		children: /* @__PURE__ */ jsx(Modal, {
			"data-slot": "modal-content",
			className: cx("row-start-2 w-full text-left align-middle", "[--visual-viewport-vertical-padding:16px]", S === "fullscreen" ? "sm:rounded-md sm:[--visual-viewport-vertical-padding:16px]" : "sm:rounded-xl sm:[--visual-viewport-vertical-padding:32px]", "relative overflow-hidden bg-overlay text-overlay-fg", "rounded-t-2xl shadow-lg ring ring-fg/5 dark:ring-border", sizes[S], "entering:slide-in-from-bottom sm:entering:zoom-in-95 sm:entering:slide-in-from-bottom-0 entering:animate-in entering:duration-300 entering:ease-out", "exiting:slide-out-to-bottom sm:exiting:zoom-out-95 sm:exiting:slide-out-to-bottom-0 exiting:animate-out exiting:ease-in", _),
			...T,
			children: /* @__PURE__ */ jsx(Dialog$1, {
				role: C,
				children: (n) => /* @__PURE__ */ jsxs(Fragment, { children: [typeof b == "function" ? b(n) : b, w && /* @__PURE__ */ jsx(DialogCloseIcon, { isDismissable: E })] })
			})
		})
	});
}, ModalTrigger = DialogTrigger$1, ModalHeader = DialogHeader, ModalTitle = DialogTitle, ModalDescription = DialogDescription, ModalFooter = DialogFooter, ModalBody = DialogBody, ModalClose = DialogClose;
export { ModalDescription as a, ModalTitle as c, ModalContent as i, ModalTrigger as l, ModalBody as n, ModalFooter as o, ModalClose as r, ModalHeader as s, Modal$1 as t };
